import { NgModule } from "@angular/core";
import { FieldsetRoutingModule } from "./fieldset.routing";
import { FieldsetListModule } from "./list/fieldset-list.module";
import { FieldsetUpdateModule } from "./update/fieldset-update.module";

@NgModule({
    imports: [FieldsetRoutingModule, FieldsetListModule, FieldsetUpdateModule],
})
export class FieldsetModule {}
